import React, { useEffect, useRef, useState } from "react";
import { Autocomplete, FormControl, TextField } from "@mui/material";

import { useAuth } from "hooks/useAuth";
import { useDebounce } from "hooks/useDebounce";
import { whiteColor } from "theme";
import { QUOTE_CONSTANT } from "constant/quoteContant";

import { useFetchAgencies } from "../../hooks/useFetchAgencies";
import { useFetchAgents } from "../../hooks/useFetchAgents";

export function AdminAddQuote({ agentDetails, setAgentDetails, isDisabled, defaultData }) {
  const { user } = useAuth();
  const agencyListRef = useRef(null);
  const agentListRef = useRef(null);

  const [agencyName, setAgencyName] = useState({
    label: agentDetails?.agentCompanyName || "",
    value: agentDetails?.agentCompanyId || ""
  });
  const [agentName, setAgentName] = useState({
    label: agentDetails?.agentName || "",
    value: agentDetails?.agentId || ""
  });

  const {
    setInputValue: setAgencyValue,
    delayedInputValue: delayedAgencyValue
  } = useDebounce({ requiredLength: 3, delay: 500 });

  useEffect(() => {
    if (isDisabled) {
      setAgencyName({
        label: defaultData?.agentCompanyName || "",
        value: defaultData?.agentCompanyId || ""
      });
      setAgentName({
        label: defaultData?.agentName || "",
        value: defaultData?.agentId || ""
      });
    }
  }, [isDisabled]);

  const { setInputValue: setAgentValue, delayedInputValue: delayedAgentValue } =
    useDebounce({ requiredLength: 3, delay: 500 });

  const {
    refetchAgencies,
    agencies,
    handleScroll,
    hasMore,
    setPage,
    setHasMore
  } = useFetchAgencies(user.token, delayedAgencyValue, agencyListRef);

  const {
    agents,
    handleAgentScroll,
    hasMore: hasMoreAgent
  } = useFetchAgents(
    user.token,
    agencyName?.value,
    delayedAgentValue,
    agentListRef
  );

  useEffect(() => {
    setPage(0);
    setHasMore(true);
    refetchAgencies();
  }, [delayedAgencyValue]);

  useEffect(() => {
    setAgentDetails({
      agentId: agentName?.value,
      agentCompanyId: agencyName?.value,
      agentName: agentName?.label,
      agentCompanyName: agencyName?.label
    });
  }, [agencyName, agentName, setAgentDetails]);

  const handleAgencyChange = (e, value) => {
    const newValue = value ? value : { label: "", value: "" };
    setAgencyName(newValue);
    setAgentName({ label: "", value: "" });
    setAgencyValue(value ? null : "");
  };

  const handleAgentChange = (e, value) => {
    const newValue = value ? value : { label: "", value: "" };
    setAgentName(newValue);
    setAgentValue(value ? null : "");
  };

  return (
    <>
      <FormControl sx={{ width: "50%", mt: "1rem" }}>
        <Autocomplete
          size="small"
          noOptionsText="No Results"
          options={agencies}
          sx={{
            background: whiteColor,
            flex: 1,
            marginRight: "0.5rem"
          }}
          value={agencyName}
          filterOptions={(x) => x}
          getOptionLabel={(option) => option.label}
          getOptionValue={(option) => option.value}
          onChange={handleAgencyChange}
          onInputChange={(e, value) => setAgencyValue(value || "")}
          renderInput={(params) => (
            <TextField {...params} label={QUOTE_CONSTANT.AGENCY_NAME} />
          )}
          data-qa={QUOTE_CONSTANT.AGENCY_NAME}
          disabled={isDisabled}
          ListboxProps={{
            onScroll: handleScroll,
            style: { maxHeight: "200px", overflowY: "auto" },
            ref: agencyListRef,
            children: agencies.map((option, index) => (
              <React.Fragment key={option.id}>
                <div key={option.value}>{option.label}</div>
                {index === agencies.length - 2 && hasMore && <div />}
              </React.Fragment>
            ))
          }}
        />
      </FormControl>

      <FormControl sx={{ width: "50%", mt: "1rem" }}>
        <Autocomplete
          size="small"
          options={agents}
          noOptionsText="No Results"
          getOptionLabel={(option) => option.label}
          getOptionValue={(option) => option.value}
          value={agentName}
          filterOptions={(x) => x}
          sx={{ background: whiteColor, flex: 1 }}
          onChange={handleAgentChange}
          onInputChange={(e, value) => setAgentValue(value || "")}
          renderInput={(params) => (
            <TextField {...params} label={QUOTE_CONSTANT.AGENT_NAME} />
          )}
          data-qa={QUOTE_CONSTANT.AGENT_NAME}
          disabled={isDisabled}
          ListboxProps={{
            onScroll: handleAgentScroll,
            style: { maxHeight: "200px", overflowY: "auto" },
            ref: agentListRef,
            children: agents.map((option, index) => (
              <React.Fragment key={option.id}>
                <div key={option.value}>{option.label}</div>
                {index === agents.length - 2 && hasMoreAgent && <div />}
              </React.Fragment>
            ))
          }}
        />
      </FormControl>
    </>
  );
}
